// packages
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

// local imports
import CustomModal from '../../components/molecules/CustomModal';
import CustomTable from '../../components/molecules/CustomTable';
import { COLUMNS } from './constants';
import Footer from '../../components/organisms/Footer';
import { ProductService } from "../../service";
import GlobalFilter from '../../components/molecules/CustomTable/GlobalFilter';
import { appActions } from '../../store/slices/app';
import { productActions } from '../../store/slices/product';
import CustomSpinner from '../../components/atoms/CustomSpinner';
import editIcon from '../../assets/icon-edit.svg';
import trashIcon from '../../assets/icon-delete.svg';
import { deleteProduct } from '../../service/product';
import { useNavigate } from 'react-router';

function Products({ title }) {
    const navigate = useNavigate();
    const isLoading = useSelector((state) => state.app.isLoading);
    const products = useSelector((state) => state.product.products);
    const dispatch = useDispatch();
    const tableInstance = useRef(null);

    const [fetchTrigger, setFetchTrigger] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [deleteItem, setDeleteItem] = useState(null);

    useEffect(() => {
        const fetchProducts = async () => {
            dispatch(appActions.setLoading(true));
            try {
                const data = await ProductService.getProductsService();
                console.log(data)
                dispatch(productActions.setProducts(data))
            } catch (error) {
                console.log(error)
            } finally {
                dispatch(appActions.setLoading(false));
            }
        };

        fetchProducts();
    }, [fetchTrigger])

    const handleDelete = async (id) => {
        try {
            dispatch(appActions.setLoading(true));
            const data = await deleteProduct(id);
            console.log(data)
            setFetchTrigger(!fetchTrigger);
        } catch (err) {
            console.log(err);
        } finally {
            dispatch(appActions.setLoading(false));
        }
    }

    const ICONS = [
        {
            id: 1,
            image: editIcon,
            onClick: async (id) => {
                console.log(id)
                navigate(`/factory/edit-product/${id}`)
            }
        },
        {
            id: 2,
            image: trashIcon,
            onClick: async (id) => {
                setDeleteItem(id);
                setModalShow(true);
            }
        },
    ]

    const MODAL_BUTTONS = [
        {
            name: 'İptal',
            variant: 'primary',
            onClick: () => setModalShow(false)
        },
        {
            name: 'Evet',
            variant: 'light',
            onClick: () => {
                handleDelete(deleteItem)
                setModalShow(false)
            }
        }
    ]

    return (
        <>
            <div className='product-list-container main-container padding-vertical-80'>
                <div className="product-list-header">
                    <h2>
                        {title}
                        {isLoading && <CustomSpinner className="ms-2 "/>}
                    </h2>
                    <GlobalFilter tableInstance={tableInstance} placeholder={'Ürün adı..'} />
                </div>
                <CustomTable
                    tableColumns={COLUMNS}
                    tableData={products}
                    tableRow={4}
                    ref={tableInstance}
                    searchBar
                    icons={ICONS}
                />
            </div>
            <Footer backButton />
            <CustomModal
                title={'Ürün Sil'}
                message={'Ürünü silmek istediğinden emin misin?'}
                buttons={
                    MODAL_BUTTONS
                }
                onOk={modalShow}
                onClose={() => setModalShow(false)}
            />
        </>
    );
}
export default Products;